import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('ButtonGroup', {
    root: (props) => css `
    max-width: ${props.maxWidth};
  `,
    inner: (props) => css `
    display: grid;
    gap: 10px 20px;
    justify-content: ${props.justify};
    grid-template-columns: repeat(auto-fit, ${props.columnSize});
  `,
});
const defaultProps = {
    columnSize: 'minmax(0, 1fr)',
    justify: 'start',
    maxWidth: 'initial',
};
export const ButtonGroup = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    return (isolateComponent("div", { css: Styles.root(props) },
        isolateComponent("div", { css: Styles.inner(props) }, props.children)));
};
//# sourceMappingURL=ButtonGroup.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
